import classes from 'components/LocationSelection/LocationSelection.module.scss'
import CurbsideImageDSG from 'assets/svg/curbside_dsg.svg';
import CurbsideImageGG from 'assets/svg/curbside_gg.svg';
import CurbsideImagePL from 'assets/svg/curbside_pl.svg';
import InStoreImageDSG from 'assets/svg/in_store_dsg.svg';
import InStoreImageGG from 'assets/svg/in_store_gg.svg';
import InStoreImagePL from 'assets/svg/in_store_pl.svg';
import Button from '@material-ui/core/Button';
import Constants from 'config/constants';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

export default function LocationSelection(props) {
	const buttonTheme = createMuiTheme({
		palette: {
			primary: {
				main: props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			}
		}
	});

	return (
		<div data-test-id="location-selection-main">
			<div className={classes.Title}>
				<p className="body-small bold upper">Where are you?</p>
			</div>
			<div className={classes.LocationSelectionContainer}>
				<div className={classes.LocationSelectionTile} onClick={() => props.handleOpenCheckIn(Constants.CHECK_IN_CURBSIDE)} data-test-id="location-selection-curbside-btn">
					<div className={classes.LocationImage}>
						<img src={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? CurbsideImageGG : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? CurbsideImagePL : CurbsideImageDSG)} alt="curbside"/>
					</div>
					<div>
						<ThemeProvider theme={buttonTheme}>
							<Button className={classes.CurbsideBtn}
											color="primary"
											variant="contained"
											onClick={() => props.handleOpenCheckIn(Constants.CHECK_IN_CURBSIDE)}>
								<p className="body-button">Curbside</p>
							</Button>
						</ThemeProvider>
					</div>
				</div>
				<div className={classes.LocationSelectionTile} onClick={() => props.handleOpenCheckIn(Constants.CHECK_IN_STORE)} data-test-id="location-selection-instore-btn">
					<div className={classes.LocationImage}>
						<img src={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? InStoreImageGG : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? InStoreImagePL : InStoreImageDSG)} alt="in store"/>
					</div>
					<div className={classes.InStoreBtnContainer}>
						<Button className={classes.InStoreBtn}
										variant="outlined"
										onClick={() => props.handleOpenCheckIn(Constants.CHECK_IN_STORE)}>
							<p className="body-button">In Store</p>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
